export default {
    en: {
        BUSINESS_UNIT: 'Business Unit',
        BUSINESS_CATEGORY: 'Business Category',
        BUSINESS_REGION: 'Business Region',
        BUSINESS_UNIT_FIELD_REQUIRED_ERROR_TEXT: 'Error: The {field} field is required.'
    }
};
